import uuid from "uuid";

import ExternalComponentRenderer from "./ExternalComponentRenderer";

class ExternalComponent extends ExternalComponentRenderer {
  constructor(props) {
    super(props);

    const self = this;
    const id = uuid();

    self.id = id;
    self.setElementId(id);
  }
  componentDidMount() {
    this.updateSelf();
  }

  componentDidUpdate() {
    this.updateSelf();
  }

  componentWillUnmount() {
    this.removeElement();
  }

  updateSelf() {
    throw new ReferenceError(`updateSelf method not implemented in child (${this.elementId})`);
  }

  render() {
    return null;
  }
}

export default ExternalComponent;



// WEBPACK FOOTER //
// ./providers/ExternalComponent.jsx